import { ReactComponent } from "./file-3-line.svg";

interface Props {
  style?: React.CSSProperties;
}

const File3LineIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default File3LineIcon;
